module.exports = __webpack_public_path__ + "img/06_full.95bf8609.jpg";